import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Dimensions } from 'react-native';
import CS from '../../../constants/Styles';
import Colors from '../../../constants/Colors';
import { BackgroundGradient, CenterSeparator, SafeAreaView, Loader } from '../../../components';
import TutorialCarouselItem from '../../../components/Carousel/Tutorial';
import { FontAwesome5, MaterialIcons } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import DataHomeowner from './data.homeowner';
import DataContractor from './data.contractor';
import Swiper from 'react-native-web-swiper';
import UserState from '../../../src/contexts/UserState';

const CreateProjectTutorial = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  const swiperRef = React.useRef(null);

  const linkTo = useLinkTo();
  const windowWidth = Dimensions.get('window').width;
  const [loading, setLoading] = React.useState(true);

  const TutorialData = user.isContractor ? DataContractor : DataHomeowner;

  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      swiperRef.current.goTo(0);
    });

    // Return the function to unsubscribe from the event so it gets removed on unmount
    return unsubscribe;
  }, [navigation]);

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, [])

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/tutorials');
    }
  }

  const slideWrapperStyle = () => {
    return {
      paddingHorizontal: 10,
      width: windowWidth > 768 ? 768 : windowWidth,
    }
  }

  return (
    <View style={{ flex: 1 }}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <View style={{ flex: 1, width: '100%', maxWidth: 768, alignSelf: 'center', }}>
        <TouchableOpacity activeOpacity={0.6} onPress={goBack} style={styles.closeButton}>
          <FontAwesome5 name="arrow-left" size={24} color="white" />
        </TouchableOpacity>
        <Swiper
          // positionFixed
          ref={swiperRef}
          containerStyle={styles.outerContainer}
          innerContainerStyle={styles.container}
          slideWrapperStyle={slideWrapperStyle()}
          controlsProps={{
            dotsTouchable: true,
            prevPos: 'left',
            nextPos: 'right',
            PrevComponent: ({ onPress }) => (
              <TouchableOpacity onPress={onPress} style={{ backgroundColor: 'rgba(0,0,0,0.65)', padding: 10, borderRadius: 100 }}>
                <MaterialIcons name="navigate-before" size={48} color={Colors.white} />
              </TouchableOpacity>
            ),
            NextComponent: ({ onPress }) => (
              <TouchableOpacity onPress={onPress} style={{ backgroundColor: 'rgba(0,0,0,0.65)', padding: 10, borderRadius: 100 }}>
                <MaterialIcons name="navigate-next" size={48} color={Colors.white} />
              </TouchableOpacity>
            ),
            dotActiveStyle: { backgroundColor: Colors.white }
          }}
        >
          {TutorialData.map((item, i) => {
            return <TutorialCarouselItem item={item} key={i} />
          })}
        </Swiper>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  outerContainer: {
    paddingHorizontal: 10,
    flex: 1,
  },
  container: {
    flex: 1,
    alignSelf: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: 20,
    left: 20,
    zIndex: 10,
  },
});

export default CreateProjectTutorial;